// @flow

import React from 'react';
import styled from 'styled-components';
import { range } from '../../../../helpers';
import type { Theme } from '../../../../types';
import { CompareItem, AddButton as AddButtonComponent } from '../../atoms';

const CompareContainer = styled<any, Theme>('div')`
  align-self: stretch;
  justify-content: space-between;
  height: ${props => props.theme.pdbCompare.height};
  display: flex;
  border-top: 1px solid ${props => props.theme.pdbCompare.borderColor};
`;

const CarContainer = styled<any, Theme>('div')`
  padding: 1rem;
  width: ${props => props.theme.pdbCompare.width};
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  flex-direction: column;
  position: relative;
  border-right: 1px solid ${props => props.theme.pdbCompare.borderColor};
  &:last-child {
    border: none;
  }
`;

const AddButton = styled<typeof AddButtonComponent, Theme>(AddButtonComponent)`
    margin-top: 2rem;
`;

type Props = {
  pdbIds: Array<string>,
};

const CompareItems = ({
  pdbIds,
}: Props) => {
  const items = range(0, 3).map(index => pdbIds[index]);

  return (
    <CompareContainer>
      {items.map((pdbId, index) => (
        <CarContainer
          key={`${pdbId}-${index}`} // eslint-disable-line react/no-array-index-key
        >
          {pdbId ? (
            <CompareItem
              key={pdbId}
              pdbId={pdbId}
            />
          ) : (
            <AddButton />
          )}
        </CarContainer>
      ))}
    </CompareContainer>
  );
};

export default CompareItems;
